import type { MultiKind } from '@anytracker/core'

import { OptionListEditor } from './OptionListEditor.js'
import styles from './TrackEditor.module.css'

interface Props {
  readonly kind: MultiKind
  readonly onChange: (kind: MultiKind) => void
  /** Option ids that measurements already point at, so they cannot be deleted. */
  readonly recordedOptionIds: ReadonlySet<string>
  readonly newOptionId: () => string
}

/**
 * Several of a set: the same option list, and deliberately no order toggle.
 *
 * An enum offers one because an ordered list of single answers can be averaged.
 * Several answers at once have no single position on a scale to average, so the
 * question does not arise here — and offering it would promise a line chart
 * that could never be drawn.
 */
export function MultiKindEditor({
  kind,
  onChange,
  recordedOptionIds,
  newOptionId,
}: Props) {
  return (
    <>
      <p className={styles['kindNote']}>
        Any number of these can be chosen at once, and each one is counted separately.
        Choosing none records nothing at all, rather than an empty answer.
      </p>

      <OptionListEditor
        options={kind.options}
        scored={false}
        recordedOptionIds={recordedOptionIds}
        newOptionId={newOptionId}
        onChange={(options) => onChange({ ...kind, options })}
      />
    </>
  )
}
